import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#1A2332] to-[#2a3442] text-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-5xl md:text-6xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Ready to Transform Your<br />Property into Profit?
        </h2>
        
        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Join hundreds of successful hosts who have launched their Airbnb businesses with our expert guidance. Let's discuss which package is right for you.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Link 
            to="/contact"
            className="inline-flex items-center bg-[#FF6B6B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#ff5252] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap"
          >
            Schedule Free Consultation
            <i className="ri-calendar-line ml-2"></i>
          </Link>
          <a 
            href="tel:+1234567890"
            className="inline-flex items-center bg-white text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Us Now
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 bg-[#FF6B6B] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-3xl"></i>
            </div>
            <h3 className="text-lg font-bold mb-2">Quick Response</h3>
            <p className="text-gray-300 text-sm">We respond to all inquiries within 24 hours</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-[#FF6B6B] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl"></i>
            </div>
            <h3 className="text-lg font-bold mb-2">No Obligation</h3>
            <p className="text-gray-300 text-sm">Free consultation with no commitment required</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-[#FF6B6B] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-line text-3xl"></i>
            </div>
            <h3 className="text-lg font-bold mb-2">Expert Guidance</h3>
            <p className="text-gray-300 text-sm">Personalized recommendations for your property</p>
          </div>
        </div>
      </div>
    </section>
  );
}
